/**
 *
 * @author      Marc-André Appel <marc-andre@sudimage.fr>
 * @copyright   2016 Sudimage Communication
 * @license     http://opensource.org/licenses/MIT MIT
 * @link        http://www.sudimage.fr
 */

var leftSidebar = () => {
  var container = $('.sidebar-left-navigation');
  if (!container.hasClass('open')) {
    container.animate({
      left: 0
    })
      .addClass('open');
  } else {
    container.animate({
      left: '-' + container.outerWidth()
    })
      .removeClass('open');
  }
};
$('.navigation-toggle').on('click', function () {
  leftSidebar();
});
$('.close-left-sidebar').on('click', function () {
  leftSidebar();
});

/** Première visite - panneau ouvert */
var setCookie = () => {
  var d = new Date();
  d.setTime(d.getTime() + (2 * 60 * 60 * 1000));
  var expires = "expires=" + d.toUTCString();
  document.cookie = "sudimageHasSeenNavigation=true; " + expires + "; path=/";
};
var getCookie = () => {
  var name = "sudimageHasSeenNavigation=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
};
var presentNavigation = () => {
  var hasSeen = getCookie();
  if (hasSeen === "") {
    leftSidebar();
    setCookie();
    // $('.sidebar-left-navigation').addClass('open');
    // function animate() {
    //   $('.sidebar-left-navigation').removeClass('open');
    // }
    window.setTimeout(leftSidebar, 5000);
  }
};
presentNavigation();